import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    loading: true,
    membersList: [],
    membersLookup: [],
    member: null,
    success: false,
    memberDetailsSuccess: false,
    newEmail: null,
}

export const membersSlice = createSlice({
    name: 'members',
    initialState,
    reducers: {
        getMembersList: (state, action) => {
            state.loading = true
        },
        membersSuccess: (state, action) => {
            state.membersList = action.payload
            state.loading = false
        },
        membersFailed: (state, action) => {
            state.loading = false
        },
        getMembersLookup: (state, action) => {
            state.loading = true
        },
        membersLookupSuccess: (state, action) => {
            state.membersLookup = action.payload
            state.loading = false
        },
        membersLookupFailed: (state, action) => {
            state.loading = false
        },
        getMember: (state, action) => {
            state.loading = true
        },
        memberSuccess: (state, action) => {
            state.member = action.payload
            state.loading = false
        },
        memberFailed: (state, action) => {
            state.loading = false
        },
        createNewMember: (state, action) => {
            state.loading = true
        },
        updateMember: (state, action) => {
            state.loading = true
        },
        memberCreatedUpdated: (state, action) => {
            state.success = true
        },
        deleteMember: (state, action) => {},
        memberDeletedSuccessfully: (state, action) => {
            state.membersList = state.membersList.filter((c) => c.id !== action.payload.id)
        },
        memberDeletionFailed: (state, action) => {},
        resetMember: (state, action) => {
            state.member = {}
            state.loading = false
            state.success = false
            state.memberDetailsSuccess = false
            state.newEmail = null
        },
        getNewEmail: (state, action) => {},
        newEmailSuccess: (state, action) => {
            state.newEmail = action.payload
        },
        newEmailFailed: (state, action) => {},
        resetNewEmail: (state, action) => {
            state.newEmail = null
        },
        addLinkedMember: (state, action) => {
            // state.loading = true
        },
        updateLinkedMember: (state, action) => {
            // state.loading = true
        },
        deleteLinkedMember: (state, action) => {
            // state.loading = true
        },
        sendPlanLink: (state, action) => {
            state.loading = false
        },
        planLinkSent: (state, action) => {
            state.loading = false
        },
        planLinkFailed: (state, action) => {
            state.loading = false
        },
        recordCollection: (state, action) => {
            state.loading = true
        },
        recordCollectionSuccess: (state, action) => {
            state.member.profile = {...state.member.profile, is_digital_member: 0, is_active_subscription: 1}
            state.member.subscription = action.payload.member.subscription
            state.member.payment_history = action.payload.member.payment_history
            state.memberDetailsSuccess = true
            state.loading = false
        },
        recordCollectionFailed: (state, action) => {
            state.loading = false
        },
    }
});

export const {
    getMembersList,
    membersSuccess,
    membersFailed,
    getMember,
    memberSuccess,
    memberFailed,
    resetMember,
    deleteMember,
    memberDeletedSuccessfully,
    memberDeletionFailed,
    createNewMember,
    updateMember,
    memberCreatedUpdated,
    addLinkedMember,
    updateLinkedMember,
    deleteLinkedMember,

    getMembersLookup,
    membersLookupSuccess,
    membersLookupFailed,

    sendPlanLink,
    planLinkSent,
    planLinkFailed,

    recordCollection,
    recordCollectionSuccess,
    recordCollectionFailed,

    getNewEmail,
    newEmailSuccess,
    newEmailFailed,
    resetNewEmail,
} = membersSlice.actions;

export default membersSlice.reducer;
